import React, { useState } from "react";
import Pagination from "rc-pagination";

import Spinner from "../spinner/spinner.component";

const CustomPagination = ({ currentPage, onPaginationPageChange, t, ...otherProps }) => {

  const [current, setCurrent] = useState(currentPage);

  const locale = {
    items_per_page: t('pagination:items_per_page', { ns: "pagination" }),
    jump_to: t('pagination:jump_to', { ns: "pagination" }),
    jump_to_confirm: t('pagination:jump_to_confirm', { ns: "pagination" }),
    page: t('pagination:page', { ns: "pagination" }),
    prev_page: t('pagination:prev_page', { ns: "pagination" }),
    next_page: t('pagination:next_page', { ns: "pagination" }),
    prev_5: t('pagination:prev_5', { ns: "pagination" }),
    next_5: t('pagination:next_5', { ns: "pagination" }),
    prev_3: t('pagination:prev_3', { ns: "pagination" }),
    next_3: t('pagination:next_3', { ns: "pagination" }),
    page_size: t('pagination:page_size', { ns: "pagination" }),
  };

  const handleChange = (page) => {
    setCurrent(page);
    onPaginationPageChange(page);
  };

  if (otherProps.loading) {
    return <Spinner color="#ffc805" display="block" size="50px" />;
  }

  return (
    <Pagination
      className="default-pagination"
      onChange={handleChange}
      current={current}
      locale={locale}
      {...otherProps}
    />
  );
};
export default CustomPagination;
